(async () => {
    const { Core } = await importModule('Core');
    const EL_PARENT = '[data-cart-item]';
    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_LINE_KEY = 'line';
    const ATTR_ITEM_KEY = 'key';
    const KEY_ENTER = 'Enter';
    
    class CartControl extends Core {
        subscriptions = {
            'cart:error': '_onCartError'
        }

        // A successful change replaces this element wholesale, so the guard only
        // ever has to survive until the response lands. On failure 'cart:error'
        // re-arms it — otherwise the row stays locked behind its spinner.
        busy = false;

        get variantId() {
            return this.getAttribute(ATTR_VARIANT_ID);
        }

        get sellingPlanId() {
            return this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
        }
        
        get $parentItem() {
            return this.closest(EL_PARENT);
        }

        get line() {
            return this.getAttribute(ATTR_LINE_KEY)
        }

        get key() {
            return this.getAttribute(ATTR_ITEM_KEY);
        }

        parentLoading() {
            this.busy = true;
            this.$parentItem?.classList.add(CN_LOADING);
        }

        _onCartError() {
            this.busy = false;
            this.$parentItem?.classList.remove(CN_LOADING);
        }

        _watchCartErrors() {
            this.subscribe('cart:error', { global: true });
        }
    }

    customElements.define('cart-qty-button', class extends CartControl {
        render() {
            this.addEventListener('click', this._onQtyChange.bind(this));
            this._watchCartErrors();
        };

        _onQtyChange(e) {
            e.preventDefault(); // the <a> falls back to a full page load without this
            if (this.busy) return;
            this.parentLoading();
            this.publish('cart:change', {
                id: this.variantId,
                key: this.key, 
                quantity: this.value,
                selling_plan: this.sellingPlanId,
                line: this.line,
                src: this.tagName
            })
        };

        get value() {
            return this.getAttribute('set-value');
        }
    });

    customElements.define('cart-qty-input', class extends CartControl {
        render() {
            this.addEventListener('change', this._onQtyChange.bind(this));
            this.addEventListener('keydown', this._onKeyDown.bind(this));
            this._watchCartErrors();
        };

        // This input lives inside the cart form, whose default submit button is the
        // checkout button (rendered in the sidebar with form="cartForm-..."). Enter
        // would therefore implicitly submit it: the navigation aborts the update
        // request below and hands the customer to checkout mid-edit.
        _onKeyDown(e) {
            if (e.key !== KEY_ENTER) return;
            e.preventDefault();

            // defaultValue is the server-rendered quantity, so this skips the
            // pointless roundtrip when Enter is pressed on an untouched field.
            if (e.target.value === e.target.defaultValue) return;

            this._onQtyChange(e);
        };

        _onQtyChange(e) {
            if (this.busy) return;
            this.parentLoading();
            this.publish('cart:change', {
                id: this.variantId,
                key: this.key, 
                quantity: e.target.value,
                selling_plan: this.sellingPlanId,
                line: this.line,
                src: this.tagName
            })
        };
    });
})();